import { FileUpload } from "../../../../shared/ui";
import { Controller } from "react-hook-form";

import type { FieldValues, UseControllerProps } from "react-hook-form";

interface VacancyControlInputTextProps<T extends FieldValues> extends UseControllerProps<T> {
    onChangeFill: () => void;
    className?: string;
}

export const VacancyControlInputFile = <T extends FieldValues>({
    name,
    className,
    control,
    onChangeFill,
}: VacancyControlInputTextProps<T>) => (
    <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value, ...props } }) => (
            <FileUpload
                accept=".docx, .pdf"
                className={className}
                onFileChange={(file) => {
                    onChange(file);
                    onChangeFill();
                }}
                data={value}
                {...props}
            />
        )}
    />
);
